import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderModule } from '../header/header.module';
import { RouterModule } from '@angular/router';
import { CreateQuoteComponent } from './create-quote/create-quote.component';
import { ViewQuoteComponent } from './view-quote/view-quote.component';
import { ViewQuotesListComponent } from './view-quotes-list/view-quotes-list.component';
import { BindNIssueComponent } from './bind-nissue/bind-nissue.component';
import { ConfirmRateComponent } from './confirm-rate/confirm-rate.component';
import { QuoteBoundComponent } from './quote-bound/quote-bound.component';
import { BusinessLookupModule } from '../business-lookup/business-lookup.module';
import { jqxTabsModule } from 'jqwidgets-ng/jqxtabs';
import { WaiverFormsModalComponent } from './waiver-forms-modal/waiver-forms-modal.component';

@NgModule({
  declarations: [
    CreateQuoteComponent, 
    ViewQuoteComponent, 
    ViewQuotesListComponent,
    BindNIssueComponent,
    ConfirmRateComponent,
    QuoteBoundComponent,
    WaiverFormsModalComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    HeaderModule,
    RouterModule,
    BusinessLookupModule,
    jqxTabsModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    BusinessLookupModule,
    ViewQuotesListComponent
  ],
  entryComponents: [
    WaiverFormsModalComponent
  ]
})
export class DiceModule { }